export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 200;
export const PASSWORD_REQUIREMENTS_MESSAGE = "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a special character.";

export type PasswordRequirement = {
  key: string;
  label: string;
  met: boolean;
};

export function getPasswordRequirements(password: string): PasswordRequirement[] {
  return [
    { key: "length", label: `At least ${PASSWORD_MIN_LENGTH} characters`, met: password.length >= PASSWORD_MIN_LENGTH },
    { key: "uppercase", label: "One uppercase letter", met: /[A-Z]/.test(password) },
    { key: "lowercase", label: "One lowercase letter", met: /[a-z]/.test(password) },
    { key: "number", label: "One number", met: /\d/.test(password) },
    { key: "special", label: "One special character", met: /[^A-Za-z0-9\s]/.test(password) },
  ];
}

export function isStrongPassword(password: string): boolean {
  return password.length <= PASSWORD_MAX_LENGTH && getPasswordRequirements(password).every((requirement) => requirement.met);
}
